import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const styles = (theme: Theme) => {
	return createStyles({
		divWrapper_container: {
			'&:focus': {
				outline: `1px dotted ${theme.palette.grey[500]}`,
			}
		},
	});
}

export default styles;
